import { useNavigate } from "react-router-dom";

function NavbarDesktop() {
  const navigate = useNavigate();

  // const logIn = (event) => {
  //   event.preventDefault();
  //   navigate("/admin");
  // };

  const Home = (event) => {
    event.preventDefault();
    navigate("/");
  };

  const Service = (event) => {
    event.preventDefault();
    navigate("/service");
  };

  const About = (event) => {
    event.preventDefault();
    navigate("/about");
  };

  const Project = (event) => {
    event.preventDefault();
    navigate("/project");
  };

  const Contact = (event) => {
    event.preventDefault();
    navigate("/contact");
  };

  return (
    <>
    <div className="xl:h-14">
      <nav className="xl:w-full fixed bg-slate-600 z-50">
        <div className="Container xl:flex items-center h-full">
          <div
            className="w-full flex justify-center items-center cursor-pointer"
            dir="rtl"
          >
            <ul>
              <li>
                <p onClick={Home}>خانه</p>
              </li>
              <li>
                <p onClick={Service}>خدمات</p>
              </li>
              <li>
                <p onClick={About}>درباره من</p>
              </li>
              <li>
                <p onClick={Project}>آخرین پروژه ها</p>
              </li>
              <li>
                <p onClick={Contact}>تماس با من</p>
              </li>
              <li>
                <p onClick={Home}>درگاه پرداخت</p>
              </li>
              <li>
                <p><a href="https://firebasestorage.googleapis.com/v0/b/siteamirhossein-259bc.appspot.com/o/AmirHosseinseifi.pdf?alt=media&token=c4472940-19ea-4590-bbe6-10ac7da4ab7e">دانلود رزومه</a></p>
              </li>
            </ul>
          </div>
          {/* logo */}
          <div className="hidden xl:w-1/2 xl:flex justify-end items-center">
            <img
              src="logo.jpeg"
              className="rounded-lg cursor-pointer"
              onClick={Home}
              alt="logo"
            />
          </div>
        </div>
      </nav>
    </div>  
    </>
  );
}

export default NavbarDesktop;
